import { render, staticRenderFns } from "./Landpage2.vue?vue&type=template&id=94cadb24&scoped=true&"
var script = {}
import style0 from "./Landpage2.vue?vue&type=style&index=0&id=94cadb24&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94cadb24",
  null
  
)

export default component.exports